import { Box, LinearProgress, Skeleton, Typography } from '@mui/material';
import { useStorageUsage } from '../../hooks/useStorageUsage';
import { formatFileSize } from './formatFileSize';

function getBarColor(percentage: number): 'primary' | 'warning' | 'error' {
  if (percentage > 95) {
    return 'error';
  }
  if (percentage >= 80) {
    return 'warning';
  }
  return 'primary';
}

export function StorageBar() {
  const { data, isLoading } = useStorageUsage();

  if (isLoading) {
    return (
      <Box sx={{ px: 2, py: 1 }}>
        <Skeleton variant="rectangular" height={6} sx={{ borderRadius: 1 }} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const percentage =
    data.maxStorageSizeBytes > 0
      ? (data.currentStorageUsageBytes / data.maxStorageSizeBytes) * 100
      : 0;

  return (
    <Box
      data-testid="storage-bar"
      sx={{
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <LinearProgress
        variant="determinate"
        value={Math.min(percentage, 100)}
        color={getBarColor(percentage)}
        sx={{ flex: 1, height: 6, borderRadius: 1 }}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {formatFileSize(data.currentStorageUsageBytes)} /{' '}
        {formatFileSize(data.maxStorageSizeBytes)} used
      </Typography>
    </Box>
  );
}
